import * as ShowMore from "../../client/js/utils/ShowMore.ts";

export function initElement(el) {
  // Initialize in next tick so that DOM structure is there
  setTimeout(() => ShowMore.initElement(el), 0);
}
